module.exports = __webpack_public_path__ + "img/stock5.e8d17368.png";